import { render, staticRenderFns } from "./StockviewSalesOverview.vue?vue&type=template&id=27179442&"
import script from "./StockviewSalesOverview.vue?vue&type=script&lang=js&"
export * from "./StockviewSalesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports